import { Component, ElementRef, ViewChild, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { ConfirmationService } from 'primeng/api';
import { Capacitor } from '@capacitor/core';
import { InstagramGalleryComponent } from 'src/app/components/instagram-gallery/instagram-gallery.component';
import { TiktokGalleryComponent } from 'src/app/components/tiktok-gallery/tiktok-gallery.component';
import { GoogleGalleryComponent } from 'src/app/components/google-gallery/google-gallery.component';

import { MessageService } from 'primeng/api';
import { MenuItem } from 'primeng/api';
import { InstagramGalleryService } from 'src/app/services/instagram-gallery.service';
import {
  TiktokGalleryService
} from 'src/app/services/tiktok-gallery.service';

interface DropdownOption { label: string; value: string; picture: string; }

@Component({
  selector: 'app-galeria',
  templateUrl: './galeria.component.html',
  styleUrls: ['./galeria.component.scss'],
  providers: [MessageService]
})
export class GaleriaComponent implements OnInit, OnChanges {
  @Input() isFeed = false;
  /** controla se mostramos o DataView ou só emitimos JSON */
  @Input() showContent = true;
  @Input() showAutoPublish = true;
  /**
   * Relay dos 4 outputs de InstagramGalleryComponent (única aba com
   * conteúdo real — TikTok/Google só usam mediaResults). SSAPP-4 removeu a
   * segunda implementação inteira de hashtag/tags/mídias/stories que existia
   * aqui (nunca era renderizada por este template, achado confirmado por
   * grep contra galeria.component.html e contra o resto do repo) — o que
   * populava esses eventos de verdade sempre foi InstagramGalleryComponent.
   */
  @Output() hashtagResults = new EventEmitter<any[]>();
  @Output() tagsResults = new EventEmitter<any[]>();
  @Output() mediaResults = new EventEmitter<any[]>();
  @Output() storiesResults = new EventEmitter<any[]>();

  // passo 1 — só facebookAccounts é lido (por loadFacebookAccounts, chamado no initInstagram)
  facebookAccounts: DropdownOption[] = [];

  // tabs
  tabs: MenuItem[] = [];
  activeTab!: MenuItem;

  // Espelhos do estado real de InstagramGalleryComponent — sincronizados via
  // (hashtagChange)/(activeTabChange) no template, lidos externamente por
  // feed.component.ts (g.hashtag, g.activeTab).
  hashtag = '';

  // Residual: zerados por clearSelectedItems() (chamado por lives.component.ts),
  // mas quem os populava de verdade sempre foi InstagramGalleryComponent.
  media: any[] = [];
  taggedMedia: any[] = [];
  userMedia: any[] = [];
  userStories: any[] = [];

  // loading
  displayAguarde = false;

  constructor(
    private gallery: InstagramGalleryService,
    private tiktok: TiktokGalleryService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private injector: Injector
  ) { }

  @Input() enablePanelAdjustment = false;

  mediaTypeOptions = [
    { label: 'Imagem', value: 'IMAGE' },
    { label: 'Reel', value: 'VIDEO' },
    { label: 'Carrossel', value: 'CAROUSEL_ALBUM' },
  ];

  @Input() source: any;
  ngOnInit() {
    this.initBySource(this.source);
  }

  private initBySource(src: any) {
    if (src === 'instagram') {
      this.initInstagram();
    } else if (src === 'tiktok') {
      this.initTikTok();
    } else if (src === 'google') {
      this.initGoogle();
    }
  }

  @ViewChild(GoogleGalleryComponent) googleGallery?: GoogleGalleryComponent;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['source'] && !changes['source'].firstChange) {
      this.initBySource(changes['source'].currentValue);
    }
  }


  initGoogle() {
    // Aqui você pode: zerar variáveis antigas, resetar estados,
    // ou apenas deixar para o GoogleGalleryComponent cuidar.
    // Exemplo:
    this.tabs = [
      { label: 'Mídias', command: () => this.onTabChange('Mídias') },
      { label: 'Hashtag', command: () => this.onTabChange('Hashtag') },
      { label: 'Canal', command: () => this.onTabChange('Canal') },
    ];
    this.activeTab = this.tabs[0];
    this.selectedItems = [];
  }
  // TikTok
  tiktokAccountsOptions: { label: string; value: string; picture: string }[] = [];
  selectedTikTokOpenId?: string;
  loadTikTokAccounts() {
    //this.displayAguarde = true;

    // Cache-first com ETag (src/app/core/http-cache).
    const accountsResource = this.tiktok.getAccountsRevalidated();

    toObservable(accountsResource.data, { injector: this.injector }).pipe(
      filter((accs): accs is any[] => accs !== null)
    ).subscribe(accs => {
        this.tiktokAccountsOptions = accs.map((a: any) => ({
          label: a.username || a.name || a.id,
          value: a.id,
          picture: a.picture || 'assets/avatar-placeholder.png'
        }));
        // auto-seleciona 1ª, se quiser:
        if (this.tiktokAccountsOptions.length && !this.selectedTikTokOpenId) {
          this.selectedTikTokOpenId = this.tiktokAccountsOptions[0].value;
        }
        this.displayAguarde = false;


        this.showConectAccount = this.tiktokAccountsOptions.length > 0 ? false : true;
    });

    toObservable(accountsResource.error, { injector: this.injector }).pipe(
      filter((error): error is any => error !== null)
    ).subscribe(() => this.displayAguarde = false);
  }
  initTikTok() {
    this.loadTikTokAccounts(); // novo (abaixo)
    this.tabs = [
      { label: 'Mídias', command: () => this.onTabChange('Mídias') } // TikTok: só vídeos do usuário
    ];
    this.activeTab = this.tabs[0];
    // para TikTok vamos exibir thumbs como IMAGE — mantenha o options padrão
    this.selectedMediaTypes = ['IMAGE']; // opcional
  }
  initInstagram() {
    this.loadFacebookAccounts();
    this.tabs = [
      { label: 'HashTag', command: () => this.onTabChange('HashTag') },
      { label: 'Tags', command: () => this.onTabChange('Tags') },
      { label: 'Mídias', command: () => this.onTabChange('Mídias') },
      { label: 'Stories', command: () => this.onTabChange('Stories') }
    ];
    this.activeTab = this.tabs[0];

    // assim que inicializar, marca todas as opções
    const allValues = this.mediaTypeOptions.map(o => o.value);
    this.selectedHashtagMediaTypes = [...allValues];
    this.selectedTagsMediaTypes = [...allValues];
    this.selectedMediaTypes = [...allValues];
    this.selectedStoriesMediaTypes = [...allValues];
  }

  onTabChange(label: string) {
    this.activeTab = this.tabs.find(t => t.label === label)!;
  }

  selectedHashtagMediaTypes: string[] = [];
  selectedTagsMediaTypes: string[] = [];
  selectedMediaTypes: string[] = [];
  selectedStoriesMediaTypes: string[] = [];

  showHashtagLimitDialog: boolean = false;
  hashtagLimitMessage: string = '';

  public selectedFacebookAccountId?: string;
  public selectedInstagramAccountId?: string;

  onSelectedFacebookAccountIdChange(fbId: string) {
    this.selectedFacebookAccountId = fbId;
  }
  onSelectedInstagramAccountIdChange(igId: string) {
    this.selectedInstagramAccountId = igId;
  }

  @ViewChild('instaRef') instagramGalleryComp!: InstagramGalleryComponent;
  public getInstagramGalleryComp(): InstagramGalleryComponent {
    return this.instagramGalleryComp;
  }
  @ViewChild(TiktokGalleryComponent) tiktokGalleryComp!: TiktokGalleryComponent;
  public getTiktokGalleryComp(): TiktokGalleryComponent {
    return this.tiktokGalleryComp;
  }

  onSelectedItemsChange(selected: any[]) {
    this.selectedItems = selected;
  }

  showConectAccount = false;
  // — Facebook Accounts & Pages —
  private loadFacebookAccounts() {
    // Cache-first com ETag (src/app/core/http-cache).
    const accountsResource = this.gallery.getFacebookAccountsRevalidated();

    toObservable(accountsResource.data, { injector: this.injector }).pipe(
      filter((res): res is any => res !== null),
    ).subscribe(res => {
        const fbAccts = Array.isArray(res) ? res : (res as any).accounts;
        this.facebookAccounts = fbAccts.map((a: any) => ({
          label: a.name, value: a.id, picture: a.picture
        }));



        this.showConectAccount = this.facebookAccounts.length > 0 ? false : true;
    });

    // ⬅️ trata o 404 (ou qualquer erro) e devolve array vazio, igual ao comportamento anterior
    toObservable(accountsResource.error, { injector: this.injector }).pipe(
      filter((error): error is any => error !== null)
    ).subscribe(() => {
        this.facebookAccounts = [];
        this.showConectAccount = true;
    });
  }

  public autoPublish = false;

  conectTikTok() {
    this.confirmationService.confirm({
      message: `Deseja continuar?`,
      header: 'Você será redirecionado para outra página.',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.tiktokConnection();
      },
      reject: () => {
        // não faz nada se cancelar
      }
    });
  }

  tiktokConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener();

    const clientKey = 'sbawrbor1sxz11n05g'; // sua client_key
    const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/tiktok');
    const scopes = encodeURIComponent('user.info.basic,user.info.profile,video.list');
    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    let stateObj: any = { selectedStoreId };
    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }
    stateObj.nonce = Math.random().toString(36).substring(2);
    const state = btoa(JSON.stringify(stateObj));
    localStorage.setItem('tiktok_oauth_state', state);

    const url =
      `https://www.tiktok.com/v2/auth/authorize/?client_key=${clientKey}` +
      `&redirect_uri=${redirectUri}&response_type=code&scope=${scopes}&state=${state}`;

    window.open(url, 'TikTok Login', 'width=600,height=700,noopener,noreferrer');
  }



  googleConnection() {
    this.confirmationService.confirm({
      message: `Deseja continuar?`,
      header: 'Você será redirecionado para outra página.',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.googleConnection2();
      },
      reject: () => {
        // não faz nada se cancelar
      }
    });
  }

  googleConnection2(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener();

    const clientId = '814215832533-b4qkagjc0h2voi3cf80prscqj16bfn5n.apps.googleusercontent.com';
    const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/youtube');
    const scopes = encodeURIComponent(
      'openid email profile ' +
      'https://www.googleapis.com/auth/youtube.readonly ' +
      'https://www.googleapis.com/auth/youtube.force-ssl ' +
      'https://www.googleapis.com/auth/youtube ' +
      'https://www.googleapis.com/auth/youtube.upload'
    );
    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    let stateObj: any = { selectedStoreId };
    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }
    stateObj.nonce = Math.random().toString(36).substring(2);
    const state = btoa(JSON.stringify(stateObj));
    localStorage.setItem('google_oauth_state', state);

    const url =
      `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&response_type=code` +
      `&scope=${scopes}` +
      `&access_type=offline` +
      `&include_granted_scopes=true` +
      `&prompt=consent` +
      `&state=${state}`;

    window.open(url, 'Google Login', 'width=600,height=700,noopener,noreferrer');
  }
  private oauthChannel: BroadcastChannel | null = null;

  private startOAuthPopupListener(): void {

    if (this.oauthChannel) return;
    this.oauthChannel = new BroadcastChannel('oauth-channel');

    this.oauthChannel.onmessage = (event) => {
      this.initInstagram();
      switch (event.data?.type) {
        case 'instagram-connected':

          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // ⬅️ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'shopify-connected':

          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // ⬅️ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'tiktok-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // ⬅️ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'google-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // ⬅️ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        default:
          console.warn('⚠️ Tipo de mensagem desconhecido:', event.data?.type);
          break;
      }
    };
  }
  private storageBridge?: BroadcastChannel;
  private setupStorageBridgeForPopup(): void {
    if (this.storageBridge) return;
    this.storageBridge = new BroadcastChannel('oauth-storage');

    this.storageBridge.onmessage = (e) => {
      if (e.data?.type === 'request-storage') {
        // Envie as chaves que a popup precisa
        this.storageBridge?.postMessage({
          type: 'storage-dump',
          payload: {
            SelectedStoreId: localStorage.getItem('ss_SelectedStoreId'),
            user_id: localStorage.getItem('user_id'),
            tiktok_oauth_state: localStorage.getItem('tiktok_oauth_state'),
            // adicione outras chaves se quiser
          }
        });
      }
    };
  }

  ngOnDestroy(): void {
    if (this.oauthChannel) {
      this.oauthChannel.close();
      this.oauthChannel = null;
    }
    if (this.storageBridge) {
      this.storageBridge.close();
      this.storageBridge = undefined;
    }
  }

  ///////////////////
  selectedItems: any[] = [];
  public clearSelectedItems() {
    this.selectedItems = [];
    this.media = [];
    this.taggedMedia = [];
    this.userMedia = [];
    this.userStories = [];
  }
  ///////////////////

  // Escrito por lives.component.ts (clearImportedItems) — sem populador vivo
  // desde a remoção da implementação duplicada de TikTok (SSAPP-4).
  tiktokVideos: any[] = [];

  selectedPost: any = null;
  postDialogVisible: boolean = false;

  onOpenPostDialog(item: any) {
    this.selectedPost = item;
    this.postDialogVisible = true;
  }

  closePostDialog() {
    this.postDialogVisible = false;
    this.selectedPost = null;
  }

  onHashtagChange(val: string) {
    this.hashtag = val;
  }

  onActiveTabChange(val: any) {
    this.activeTab = val;
  }

  selectedGoogleAccountId?: string;
  selectedChannelId?: string;

}
